import thumbnailsModule from "../thumbnailsModule";
import { EnvironmentUrls } from "Roblox";

const { thumbnailsApi } = EnvironmentUrls;

const thumbnailConstants = {

    urls: {
        getAssetThumbnails: thumbnailsApi + "/v1/assets",
        getAvatarHeadshots: thumbnailsApi + "/v1/users/avatar-headshot",
        getBundleThumbnails: thumbnailsApi + "/v1/bundles/thumbnails",
        getGameIcons: thumbnailsApi + "/v1/games/icons",
        getGroupIcons: thumbnailsApi + "/v1/groups/icons"
    },

    requestProperties: {
        batchSize: 100
    },

    cooldown: {
        maxRetryAttempts: 10,
        minCooldown: 1000,
        maxCooldown: 30000
    },

    sizes: {
        small: "small",
        medium: "medium",
        large: "large"
    },

    sizeMap: {
        // Browsers are capable of resizing images.
        // 150x150 is the most common size to request, no reason to force smaller image sizes for now.
        small: "150x150",
        medium: "150x150",
        large: "150x150"
    },

    thumbnailTypes: {
        assetThumbnail: "assetThumbnail",
        avatarHeadshot: "avatarHeadshot",
        bundleThumbnail: "bundleThumbnail",
        gameIcon: "gameIcon",
        groupIcon: "groupIcon",
    },

    thumbnailStates: {
        error: "Error",
        complete: "Completed",
        inReview: "InReview",
        pending: "Pending",
        blocked: "Blocked"
    },
    
    formats: {
        png: "png"
    }
};

thumbnailsModule.constant("thumbnailConstants", thumbnailConstants);

export default thumbnailConstants;
